var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExampleCode = function SvgExampleCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "videogame_asset_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    d: "M20,20H4c-1.1,0-2-0.9-2-2c0,0,0,0,0,0L2,6v0c0-1.1,0.9-2,2-2h6l2,2h8c1.1,0,2,0.9,2,2v10 C22,19.1,21.1,20,20,20z M14.6,9.2l-1.4,1.4l2.6,2.6l-2.6,2.6l1.4,1.4l4-4L14.6,9.2z M9.8,9.2l-4,4l4,4l1.4-1.4l-2.6-2.6l2.6-2.6 L9.8,9.2z"
  }))));
};
export default SvgExampleCode;